export default {
  navigationBarTitleText: '客户信息管理'
};
